module.exports = __webpack_public_path__ + "static/img/gzjz.43cc3fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/gzjz.png
// module id = 6
// module chunks = 0